import { isProdLike } from "@imi/utils/env.js";
import i18n from "i18next";
import LngDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import { formatter } from "./postProcessors/formatter";

i18n
  .use(LngDetector)
  .use(HttpBackend)
  .use(formatter)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
    detection: {
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng",
      order: ["querystring", "localStorage", "navigator"],
    },
    fallbackLng: "en",
    parseMissingKeyHandler: (key) => {
      if (isProdLike(import.meta.env.VITE_ENVIRONMENT)) {
        return key;
      }
      return `[NOT TRANSLATED] ${key}`;
    },
  });

export default i18n;
